import MissingLogIcon from './MissingLogIcon';

export default MissingLogIcon;
